import { VueConstructor } from 'vue'

import { log } from '@/utils/logger'
import { featureFlagConfig } from 'aven_types'

// Vue 2.7 uses Vue.prototype / Vue.config; on the Vue 3 migration this becomes
// app.config.globalProperties and the productionTip line is dropped. Keeping these
// assignments here mirrors aven/src/config/mainConfig.ts so the migration diff is small.
export const mainConfigInit = (vue: VueConstructor) => {
    vue.prototype.$logger = log // we add logger to the prototype so that we can access it in aven_shared
    vue.prototype.$logEvent = window.logEvent
    vue.prototype.$featureFlagConfig = featureFlagConfig
    vue.config.productionTip = false
}
